import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import UploadElement from './UploadElement';

const left = css({ textAlign: 'left' });
const Upload = props => {
  const { element, ...restProps } = props;
  const { formSettings, className = '' } = element.data;

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <FormItem
          id={element.id}
          style={elementStyle}
          className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-upload', left)}
          {...formSettings}
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <UploadElement element={element} {...restProps} className={className} />
        </FormItem>
      )}
    </ElementRoot>
  );
};

export default Upload;
